export default __webpack_public_path__ + "static/media/goshow-banner.6190e45c.png";